// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"528":"reports","660":"bookOfBetting","956":"paymentsReport","962":"home"}[chunkId] || chunkId) + "." + {"79":"4240ed4d","176":"ec4f04f0","320":"1750d2d4","396":"79b39bc7","528":"62e2b467","660":"b6f1fdb0","956":"8225fc28","962":"1ad25b8c"}[chunkId] + ".js";
};